import React, { useEffect, useState } from "react";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import ProductHeader from "../ProductHeader";
import { fetchFavoriteProduct } from "../../../store/actions/auth";
import { List } from "../../Menu/List";
import Skeleton from "@material-ui/lab/Skeleton";
import MList from "@material-ui/core/List";
import LoadingCell from "../../Menu/LoadingCell";
import ActionButton from "../../ActionButton";

const FavoriteProductPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isMobile, setIsMobile] = useState(undefined);
  const language = useSelector((state) => state.store.language);
  const settings = useSelector((state) => state.store.store.settings);
  const secondLoading = useSelector((state) => state.store.secondLoading);
  const userFavoriteList = useSelector(
    (state) => state.auth?.user?.favorite_products_list
  );
  const [loading, setLoading] = useState(!userFavoriteList);
  const cart = useSelector((state) => state.cart);
  const isNotificationDismissed = useSelector(
    (state) => state.store.isNotificationDismissed
  );

  const headerTitle =
    language === "english" ? "Favorite Products" : "المنتجات المفضلة";

  const customTexts = settings.custom_texts;

  const totalCartLength = cart.cart.length + cart.promo_items.length;
  const showActionButton = () => {
    if (settings.is_menu) return false;
    if (totalCartLength === 0) return false;
    return true;
  };

  const categoryList = userFavoriteList?.map((category) => (
    <List
      key={"List_Category " + category.name + category.id}
      category={category}
      isMobile={isMobile}
      filter={false}
      filters={false}
      favorite={true}
      settings={settings}
      language={language}
      isNotificationDismissed={isNotificationDismissed}
    />
  ));

  useEffect(() => {
    if (!secondLoading && !userFavoriteList) {
      dispatch(fetchFavoriteProduct(setLoading));
    }
  }, [secondLoading]);

  const loadingSpinner = (
    <div className="pt-3">
      <Skeleton variant="rect" style={{ height: 35 }} />
      <MList
        component="nav"
        aria-label="main mailbox folders"
        style={{
          width: "100%",
          backgroundColor: "white",
          paddingBottom: 8,
          paddingTop: 8,
        }}
      >
        {[1, 2, 3, 4, 5].map((index) => (
          <LoadingCell key={index} />
        ))}
      </MList>
    </div>
  );

  const noResult = (
    <p
      style={{
        fontSize: "16px",
        padding: "50px",
      }}
    >
      {language !== "arabic" ? "Your list is empty" : "قائمتك فارغة"}
    </p>
  );

  return (
    <div>
      <ProductHeader
        title={headerTitle}
        onBack={() => {
          history.length > 2 ? history.goBack() : history.replace("/");
        }}
        rightAction={<Button type="primary">share</Button>}
      />
      <div className="free-space-50"></div>
      <div className="mb-5 w-100">
        {loading
          ? loadingSpinner
          : categoryList?.length > 0
          ? categoryList
          : noResult}
      </div>
      {showActionButton() && (
        <ActionButton
          action={
            language == "english"
              ? customTexts.review_order
              : customTexts.review_order_ar
          }
          onClick={() => {
            history.push("/cart");
          }}
          total={
            cart.cart.length <= 0
              ? null
              : cart.price.toFixed(settings.currency_decimals)
          }
          quantity={totalCartLength > 0 ? totalCartLength : null}
        />
      )}
    </div>
  );
};

export default FavoriteProductPage;
